module.exports = __webpack_public_path__ + "img/perks_D merch discount.ad00433c.jpg";